import { Heading, TextPassage } from '@petsmart-ui/sparky';

import { type FormFields, usePurchaseFormWatch } from '@/entities/purchase-form';

const details = {
    bopis: {
        text: 'Get your item for the first time by picking it up in store today or add it to the next Autoship order being shipped to you.',
    },
    sdd: {
        text: 'Get your item for the first time by having it delivered today or add it to the next Autoship order being shipped to you.',
    },
    sth: {
        text: 'Get your item for the first time by having it delivered in 1-3 days or add it to the next Autoship order being shipped to you.',
    },
};

export const AutoshipDetails = () => {
    const deliveryMethod: FormFields['fulfilmentMethod'] | undefined = usePurchaseFormWatch('fulfilmentMethod');
    const detail = details[deliveryMethod ?? 'bopis'];

    return (
        <div className="fulfilment-selection-drawer__details">
            <Heading tagName="h3" size="body-bold">
                Choose when you want your item
            </Heading>
            <TextPassage>{detail.text}</TextPassage>
            <TextPassage>All future orders will be shipped to you.</TextPassage>
        </div>
    );
};
